import React from 'react';
import { motion } from 'framer-motion';
const volumes = [{
  num: '1',
  title: 'Der Biomechanische Atlas',
  subtitle: 'PDF · 200+ Seiten',
  desc: 'Wissenschaftliche Grundlage des modernen alpinen Skilehrens. 12 Kapitel über COM-Dynamik, Kantenmechanik, Angulation, visuelle Fehlerdiagnose und KPI-System. Die technische Sprache die VIP-Kunden respektieren und Premium-Preise rechtfertigt.'
}, {
  num: '2',
  title: 'Das Technical Drill Deck',
  subtitle: '20 laminierbare Field Cards',
  desc: 'Eine vollständige Übungskarte für jede Situation auf der Piste. Wissenschaftliche Grundlage, Schritt-für-Schritt-Ausführung, häufige Fehler und messbare KPIs. Ausdrucken. Laminieren. Sofort einsetzen.'
}, {
  num: '3',
  title: 'Das Performance Tracking System',
  subtitle: 'PDF ausfüllbar',
  desc: 'Fertige KPI-Bögen, Fortschrittsberichte und Schülerdiagnosen. Dein Kunde erhält am Ende jedes Tages einen professionellen PDF-Bericht. Er denkt du arbeitest für eine Elite-Akademie.'
}, {
  num: '4',
  title: 'Der VIP-Protokoll Code',
  subtitle: 'PDF Protokoll-Handbuch',
  desc: 'Das vollständige Kommunikationssystem für Ultra-Premium-Kunden aus 15 Nationen. Kulturelle Intelligenz, Preisarchitektur und das Retainer-System das dir 20.000 CHF pro Saison sichert.'
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-white border-t border-brand-border" data-id="element-252">
      <div className="max-w-xl mx-auto" data-id="element-253">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-254">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-navy mb-3" data-id="element-255">
            Was ist drin
          </h2>
          <p className="text-sm text-brand-muted font-medium" data-id="element-256">
            Das Swiss Champions Archiv im Detail.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-257">
          {volumes.map((v, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-surface border border-brand-border p-5 rounded-2xl shadow-sm" data-id="element-258">
              <div className="flex items-start gap-3" data-id="element-259">
                <div className="bg-brand-navy text-white text-xs font-black px-2.5 py-1 rounded shrink-0 mt-1" data-id="element-260">
                  TOMO {v.num}
                </div>
                <div data-id="element-261">
                  <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-2 mb-2" data-id="element-262">
                    <h4 className="font-bold text-brand-navy text-base sm:text-lg" data-id="element-263">
                      {v.title}
                    </h4>
                    <span className="text-xs font-bold text-brand-gold uppercase tracking-wider" data-id="element-264">
                      {v.subtitle}
                    </span>
                  </div>
                  <p className="text-sm text-brand-text leading-relaxed" data-id="element-265">
                    {v.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}